export default __webpack_public_path__ + "static/media/lead.ff779a10.jpg";